import type { onboarding as onboardingEn } from '../en/onboarding';

export const onboarding: typeof onboardingEn = {
  welcome: {
    title: 'Le damos la bienvenida a First Weeks',
    body: 'Tomas, pañales, peso y chequeos para sus primeras semanas juntos, de su equipo de Families First Pediatrics.',
    chooseLanguage: 'Elija su idioma',
    english: 'English',
    spanish: 'Español',
  },

  role: {
    title: '¿Quién usará este teléfono?',
    momTitle: 'Soy la mamá',
    momHint: 'Configurar este teléfono para usted y su bebé.',
    partnerTitle: 'Soy la pareja',
    partnerHint: 'Tengo una invitación del teléfono de mamá.',
    inviteDetected: 'Encontramos una invitación en su enlace.',
  },

  baby: {
    title: '¿Ya nació su bebé?',
    expecting: 'Todavía no, estamos esperando',
    here: '¡Sí, ya nació!',
    dueDateLabel: 'Su fecha probable de parto',
    dueDateHint: 'Contaremos los días con usted y estaremos listos en cuanto llegue su bebé.',
    birthDateLabel: '¿Cuándo nació su bebé?',
    nicknameLabel: 'Apodo del bebé (opcional)',
    nicknameHint: 'Un apodo como "Chiquito" es perfecto. No hace falta el nombre real, así protege su privacidad.',
    weightLabel: 'Peso al nacer (opcional)',
    weightHint: 'Está en los papeles del hospital. También puede agregarlo después en Configuración.',
    finish: 'Comenzar a registrar',
  },

  partner: {
    title: 'Conectar con el teléfono de mamá',
    body: 'Escriba el código de invitación del teléfono de mamá. Ella puede crearlo en Configuración, en Conexión con su pareja.',
    connectedTitle: '¡Conectados!',
    connectedBody: 'Todo listo. Lo que cualquiera de los dos registre aparecerá en ambos teléfonos.',
  },

  privacyNote:
    'Sus datos se quedan en este teléfono. No se envía nada a ningún lado a menos que se conecte con su pareja, y aun así va cifrado para que solo sus dos teléfonos puedan leerlo.',
};
